import { useState } from "react";
import Button from "../../../../components/Button";
import Modal from "../../../../components/modals/Modal";
import { doc } from "firebase/firestore";
import { firestore } from "../../../../firebase/config";
import generateMixerTeams from "../../../../functions/generateMixerTeams";

const CreateMixerTeams = ({ tournamentId, playerIds, profiles }) => {
  const isDisabled = playerIds?.length < 12;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const writeTeams = () => {
    const teamsRef = doc(firestore, "teams", tournamentId);

    const groupedPlayerIds = generateMixerTeams(playerIds, profiles);

    console.log(groupedPlayerIds);
  };

  return (
    <>
      <Button color="green" disabled={isDisabled} onClick={toggleModal}>
        Create Mixer Teams
      </Button>

      <Modal
        isOpen={isModalOpen}
        onCancel={toggleModal}
        onConfirm={writeTeams}
        title={"Create Mixer Teams"}
        subtitle={"Generate balanced teams based on players skill level"}
      ></Modal>
    </>
  );
};

export default CreateMixerTeams;
